import Image from "@/components/AppImage";
import Link from "@/components/AppLink";
import apple_btn from "/public/img/apple_btn.png";
import gPlay_btn from "/public/img/gPlay_btn.png";

const Banner = () => {
  return (
    <section className="banner-section index-10">
      <div className="overlay">
        <div className="banner-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <h1>Bank-grade security for every freelancer payout</h1>
                  <p className="xxlr">
                    Encryption, device checks, and real-time fraud signals wrap
                    every transfer—whether you are paying a subcontractor or
                    collecting from a Fortune 500 client.
                  </p>
                  <div className="app-market">
                    <Link href="#">
                      <Image src={gPlay_btn} alt="App Store" />
                    </Link>
                    <Link href="#">
                      <Image src={apple_btn} alt="App Store" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
